<template>
    <div class="unauthorized-content">
        <i class="pi pi-lock lock-icon"></i>
        <h1 class="title">{{ title }}</h1>
        <p class="message">{{ message }}</p>
        <div class="action-buttons">
            <Button
                label="Go to Home"
                icon="pi pi-home"
                @click="goHome"
                class="mr-2"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import Button from "primevue/button";
import { computed, inject, Ref } from "vue";
import { useRouter } from "vue-router";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import type { UnauthorizedAccessData } from "@/composables/unauthorized-access-dialog";

// Get dialog reference
const dialogRef = inject<Ref<DynamicDialogInstance>>("dialogRef");

// Get dialog data
const dialogData = (dialogRef?.value?.data as UnauthorizedAccessData) || {};

// Default values
const defaultMessage = "You don't have permission to access this resource.";
const defaultTitle = "Access Denied";

// Computed properties for display
const title = computed(() => {
    if (dialogData.status === 401) return "Authentication Required";
    return defaultTitle;
});

const message = computed(() => {
    return dialogData.message || defaultMessage;
});

// Access router
const router = useRouter();

// Navigation functions
const goHome = () => {
    router.push("/");
    dialogRef?.value.close();
};
</script>

<style scoped>
.unauthorized-content {
    text-align: center;
    padding: 2rem;
}

.lock-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
    color: var(--primary-color);
}

.title {
    font-size: 1.75rem;
    font-weight: bold;
    margin-bottom: 1rem;
}

.message {
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
}

.action-buttons {
    display: flex;
    justify-content: center;
    gap: 1rem;
}

@media (max-width: 640px) {
    .action-buttons {
        flex-direction: column;
    }

    .action-buttons .p-button {
        margin-right: 0 !important;
        margin-bottom: 0.5rem;
    }
}
</style>
